module.exports = __webpack_public_path__ + "img/img-exercise-muscle-03.43d168e4.png";